<template>
  <div class="qpage">
    <div  v-if="comment" class="forum w-clearfix">
      <router-link :to="'/path/'+comment.path[0].itemRefID+'/chapter/'+comment.chapterId+'/lesson/'+comment.lessonId">חזרה לשיעור</router-link>
    <div class="qa-head">
      <h2 class="cont-head qa">{{comment.title}}</h2>
      <p class="top-name">{{comment.name}}</p>
      <p class="top-date">{{createdDate}}</p>
      <p class="top-date">{{comment.replies.length || 0}} תגובות</p>
    </div>
    <div class="rich-txt w-richtext" v-html="comment.content">
    </div>
    <h3 class="field-label">שיח</h3>

      <div v-if="comment.replies" >
        <div v-for="reply in comment.replies" :key="reply._id" class="reply">
      <div class="name-date">
        <p class="info-name">{{reply.name}}</p>
        <p class="date-info">{{new Date(reply._createdDate).toLocaleString("he-IL")}}</p>
      </div>
      <div class="rich-txt ans w-richtext">
        <h2>{{reply.title}}</h2>
        <div v-html="reply.content"></div>
      </div>
        </div>
      </div>
    <div class="qa-box">


      <div class="w-form">
        <form
                id="email-form"
                name="email-form"
                data-name="Email Form"
                class="w-clearfix"
                @submit.prevent="postSubComment()"
        >
          <label for="node" class="field-label">
            תגובה חדשה
            <br />
          </label>
          <input
                  type="text"
                  class="text-field w-input"
                  maxlength="256"
                  data-name="כותרת"
                  placeholder="כותרת"
                  v-model="newComment.title"
                  required
          />
          <div id="app">
            <editor class="text-field big w-input" v-model="newComment.content" placeholder="הוסף שאלה או הערה..."
                    api-key="0osf650psj1649yurge59pgmpyar9h76bwjlxcrgrrnayxmu"
                    :init="{
         directionality:'rtl',
         height: 230,
         menubar: false,
         branding: false,
         word_counting: false,
         resize: false,
         statusbar: false,
         content_css:'/richtext/style.css',
         plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks fullscreen',
           'insertdatetime media table'
         ],
         toolbar:
           'undo redo | bold italic backcolor | \
            | \
           bullist numlist outdent indent'
       }"
            />
          </div>
          <br />
          <smart-button :loading="loading">שליחה</smart-button>
        </form>
      </div>
    </div>
    </div>
    <div v-else style="text-align: center">
      <loader/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import loader from "../components/loader";
import smartButton from "../components/button";
//import { DATA_LOADING_STATE } from "@/store/enums";
import Editor from "@tinymce/tinymce-vue";

  export default {
  name: "fullComment",
    components:{loader,     smartButton,
      editor: Editor,},
  data: function () {
      return {
        loading:false,
        newComment:{content:"",title:""},
        comment:null
      }
  },
  // props: {
  //   comment: Object,
  // },
    mounted() {
    // console.log('now in mounted of ***fullComment***')
      this.$store.dispatch('fetchCommentById', this.$route.params.commentID)
    },
    methods: {
      async postSubComment(){
          await this.$store.dispatch("postSubComment",{title:this.newComment.title,content:this.newComment.content})
          this.newComment = {title:"",content:""}
      },
      replyCreatedDate(reply) {
        let date = new Date(reply._createdDate);
        return `${date.getDate()}/${
                date.getMonth() + 1
        }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      },
  },
  computed: {
    ...mapGetters(['getSelectedComment']),
    createdDate() {
      let date = new Date(this.comment._createdDate);
      return `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    },
  },
    watch:{
      getSelectedComment(){
        this.comment = this.getSelectedComment;
      }
    }
};
</script>


<style >
  .qpage{
    background-color: #f9f9f9;
    width: 90%;
    max-width: 900px;
    margin:140px auto;
  }
  .forum{
    padding-top: 50px;
    padding-bottom: 50px;
  }
  [title=Fullscreen]{
    float: right;
  }
  .tox-toolbar__group{
    border-color:  #2E5BFF25 !important;
  }
  .tox .tox-dialog{
    /* border:none !important; */
    border-radius: 12px!important;
  }
  .tox .tox-editor-header {
    z-index: auto !important;
    /* border: none !important; */
  }
  .tox .tox-toolbar, .tox .tox-toolbar__overflow, .tox .tox-toolbar__primary{
    background: #f6f6f6 !important;
  }
  .tox-tinymce{
    border: none!important;
    padding: 2px;
  }
  .tox .tox-tbtn--enabled{
    background: #88ca4e !important;
    color: white !important;
  }
  .tox-tbtn--enabled svg{
    fill: white !important;
  }
  .tox-tbtn--enabled:hover svg{
    fill:  #222F3E !important;
  }
  .tox-tbtn--enabled:hover {
    color:  #222F3E !important;
  }
  .tox-tbtn:hover{
    background: #2E5BFF25 !important;
  }
  .tox-editor-container{
    @apply rounded
  }
  .tox .tox-collection--list .tox-collection__item--active{
    background: #88ca4e !important;
  }
  .tox-notifications-container {
    display: none !important;
  }
  .top-menu.ftf.w-clearfix {
    display: none;
  }
  .reply{
    position: relative;
  }
  .name-date{
        text-align: left;
        max-width: 170px;
        float: right;
        margin-left: 15px;
  }
  .reply{
    margin-bottom: 20px;
  }
</style>
